((global) => {// 全局函数、禁止写自运行函数
  window.publicComponents = window.publicComponents || {}
  if (typeof window.publicComponents.messageOpen !== 'function') {
    window.publicComponents.messageOpen = function (options) {
      const config = options || {}
      const content = String(config.content || '').trim()
      if (!content) return

      const type = config.type || 'info'
      const style = config.style || {}
      let toast = document.querySelector('[data-public-message-toast]')
      if (!toast) {
        toast = document.createElement('div')
        toast.setAttribute('data-public-message-toast', '')
        toast.setAttribute('role', 'status')
        toast.setAttribute('aria-live', 'polite')
        toast.style.position = 'fixed'
        toast.style.left = '50%'
        toast.style.top = '20%'
        toast.style.zIndex = '10000'
        toast.style.maxWidth = 'min(680px, calc(100vw - 32px))'
        toast.style.padding = '12px 18px'
        toast.style.borderRadius = '6px'
        toast.style.fontSize = '16px'
        toast.style.lineHeight = '1.4'
        toast.style.boxShadow = '0 14px 36px rgba(32, 9, 16, 0.14)'
        toast.style.transform = 'translate(-50%, -8px)'
        toast.style.opacity = '0'
        toast.style.pointerEvents = 'none'
        toast.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
        document.body.appendChild(toast)
      }

      Object.keys(style).forEach((key) => {
        toast.style[key] = style[key]
      })

      toast.textContent = content
      if (type === 'success') {
        toast.style.background = '#e8f5e9'
        toast.style.color = '#1b5e20'
      } else if (type === 'error') {
        toast.style.background = '#ffebee'
        toast.style.color = '#b71c1c'
      } else {
        toast.style.background = '#fff4f7'
        toast.style.color = '#200910'
      }

      window.clearTimeout(toast.__messageOpenTimer)
      requestAnimationFrame(() => {
        toast.style.opacity = '1'
        toast.style.transform = 'translate(-50%, 0)'
      })
      toast.__messageOpenTimer = window.setTimeout(() => {
        toast.style.opacity = '0'
        toast.style.transform = 'translate(-50%, -8px)'
      }, config.duration || 4200)
    }
  }

  global.htEncrypt = function (data) {
    const { cryptoEncodeKey } = global.injectInterfaceParams()
    const key = CryptoJS.enc.Utf8.parse(cryptoEncodeKey)
    const srcs = CryptoJS.enc.Utf8.parse(data)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  }

  global.decodeResponse = function (data) {
    const { cryptoDecodeKey } = global.injectInterfaceParams()
    const key = CryptoJS.enc.Utf8.parse(cryptoDecodeKey)
    const decrypt = CryptoJS.AES.decrypt(data, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }

  // 获取IP属地信息
  global.getIPInfo = function (callback) {
    const {
      hostName,
      platCode,
      accountGroup,
      platform,
    } = global.injectInterfaceParams()
    try {
      $.ajax({
        url: hostName + '/general/front/address/country/ipInfo',
        type: 'POST',
        headers: {
          'Hetectx-Plat-Code': platCode,
          'Hetectx-Account-Group': accountGroup,
          'Hetectx-Platform': platform
        },
        success: function (resp) {
          if (!resp || resp.code !== 'SUCCESS') { return }
          var { countryCode } = JSON.parse(global.decodeResponse(resp.data))
          localStorage.setItem('__H2T_i&P_SESS', JSON.stringify({ country: countryCode.toUpperCase(), time: Date.now() }))
          callback && callback(countryCode)
        },
        error: function (err) {
          callback && callback('')
          console.log('ip service error', err)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  // 检查IP缓存是否有效
  global.validateLocation = function (forbit_country_abbr = []) {
    const IP_SESS = localStorage.getItem('__H2T_i&P_SESS')
    const now = Date.now()
    if (IP_SESS) {
      const { country, time } = JSON.parse(IP_SESS)
      const sessionTime = (now - time) / (60 * 1000)  // 缓存了多少分钟
      if (!forbit_country_abbr.includes(country.toUpperCase()) && sessionTime > 24 * 60) {
        // 不在限制名单，但是缓存超过一天，需要重新获取
        return false
      } else if (forbit_country_abbr.includes(country.toUpperCase()) && sessionTime > 5) {
        // 在限制名单，同时缓存超过了5分钟，需要重新获取
        return false
      }
    } else {
      return false
    }
    return true
  }
  // 根据IP判断首页地址
  global.redirectHomePageByIP = function () {
    if (window.location.pathname !== "/") {
      localStorage.setItem("visitedNotHomePage", 'true')
      return
    }
    if (localStorage.getItem('visitedNotHomePage') === 'true') {
      return
    }
    const isGoogleBot = /googlebot|bingbot|yahoo! slurp|duckduckbot|ecosiabot/i.test(navigator.userAgent)
    if (isGoogleBot) {
      return
    }
    const country = [
      "Algeria", "Egypt", "Ethiopia", "Angola", "Benin", "Botswana",
      "Burkina Faso", "Burundi", "Equatorial Guinea", "Togo", "Eritrea", "Cape Verde",
      "Gambia", "Congo", "D.R.Congo", "Djibouti", "Guinea", "Guinea-Bissau",
      "Ghana", "Gabon", "Zimbabwe", "Cameroon", "Comoros", "Côte d'lvoire", "Kenya",
      "Lesotho", "Liberia", "Libya", "Rwanda", "Madagascar", "Malawi",
      "Mali", "Mauritius", "Mauritania", "Morocco", "Mozambique", "Namibia",
      "South Africa", "South Sudan", "Niger", "Nigeria", "Sierra Leone", "Senegal",
      "Seychelles", "São Tomé & Principe", "Swaziland", "Sudan", "Somalia", "Tanzania",
      "Tunisia", "Uganda", "Zambia", "Chad", "Central Africa", "The Republic of South Africa"]
    const country_abbr = [ // 国家简称
      'DZ', 'EG', 'ET', 'AO', 'BJ', 'BW',
      'BF', 'BI', 'GQ', 'TG', 'ER', 'CV',
      'GM', 'CG', 'CD', 'DJ', 'GN', 'GW',
      'GH', 'GA', 'ZW', 'CM', 'KM', 'CI', 'KE',
      'LS', 'LR', 'LY', 'RW', 'MG', 'MW',
      'ML', 'MU', 'MR', 'MA', 'MZ', 'NA',
      'ZA', 'SS', 'NE', 'NG', 'SL', 'SN',
      'SC', 'ST', 'SZ', 'SD', 'SO', 'TZ',
      'TN', 'UG', 'ZM', 'TD', 'CF', 'ZA',
    ]
    const url = window.location.href
    let parameter = ''
    if (url.indexOf("?") !== -1) {
      parameter = url.split("?")[1]
    }
    const redirectUrl = `https://za.luvmehair.com/${parameter ? '?' + parameter : ''}`
    const IP_SESS = localStorage.getItem('__H2T_i&P_SESS')
    if (IP_SESS) {
      // 存在IP属地缓存
      let sessionCountry = JSON.parse(IP_SESS)?.country
      const isValid = global.validateLocation(country_abbr) // 检查缓存是否有效
      if (!isValid) {
        // 缓存过期，重新获取
        global.getIPInfo(function (countryCode) {
          if (country_abbr.includes(countryCode.toUpperCase())) {
            window.location.href = redirectUrl
          }
        })
      } else {
        // 缓存有效，直接判断
        if (country_abbr.includes(sessionCountry.toUpperCase())) {
          window.location.href = redirectUrl
        }
      }
    } else {
      // 不存在缓存信息，直接获取
      global.getIPInfo(function (countryCode) {
        if (country_abbr.includes(countryCode.toUpperCase())) {
          window.location.href = redirectUrl
        }
      })
    }
  }

  // 是否带有管理员标识
  global.isAdminVisitor = function () {
    const href = top.location.href
    const adminSessionName = 'HT_IP_FORBIDDEN_CHANNEL'
    return href.indexOf(`${adminSessionName}=`) !== -1 || href.indexOf('/admin/themes/') !== -1 || href.indexOf('shopifypreview.com') !== -1 || localStorage.getItem(adminSessionName) != null
  }

  // 根据IP判断是否限制访问
  global.checkIPDeny = function (prohibitLayer) {
    // 国家全称
    const asiaCountries = ['China', 'Mongolia', 'Korea', 'South Korea', "Vietnam", "Laos",
      "Cambodia", "Myanmar", "Thailand", "Philippines", "Malaysia", "Brunei",
      "Singapore", "Indonesia", "East Timor", "Nepal", "Bhutan", "Bangladesh",
      "India", "Pakistan", "Sri Lanka", "Maldives", "Kazakhstan", "Kyrgyzstan",
      "Tajikistan", "Uzbekistan", "Turkmenistan", "Afghanistan", "Iran", "Iraq",
      "Syria", "Lebanon", "Israel", "Palestine Jordan", "Saudi Arabia", "Kuwait",
      "Bahrain", "Qatar", "United Arab Emirates", "Oman", "Yemen", "Georgia",
      "Armenia", "Azerbaijan", "Turkey", "Cyprus", "Russia and Siberia", "Hong Kong", "Taiwan"].map(country => (country.toLowerCase()))
    // 国家简称
    const country_abbr = [
      'CN', 'MN', 'KP', 'KR', 'VN', 'LA',
      'KH', 'MM', 'TH', 'PH', 'MY', 'BN',
      'SG', 'ID', 'TL', 'NP', 'BT', 'BD',
      'IN', 'PK', 'LK', 'MV', 'KZ', 'KG',
      'TJ', 'UZ', 'TM', 'AF', 'IR', 'IQ',
      'SY', 'LB', 'IL', 'JO', 'SA', 'KW',
      'BH', 'QA', 'AE', 'OM', 'YE', 'GE',
      'AM', 'AZ', 'TR', 'CY', 'RU', 'HK', 'TW'
    ]
    const adminSessionName = 'HT_IP_FORBIDDEN_CHANNEL'
    const SESS_NAME = '__H2T_i&P_SESS'
    const IP_SESS = localStorage.getItem(SESS_NAME)
    if (!global.isAdminVisitor()) {
      // 1. 获取IP缓存
      const isValid = global.validateLocation(country_abbr)
      if (!IP_SESS || !isValid) {
        global.getIPInfo(function (countryCode) {
          if (country_abbr.includes(countryCode.toUpperCase())) {
            prohibitLayer && prohibitLayer()
          }
        })
      } else if (isValid) {
        const { country } = JSON.parse(IP_SESS)
        if (country_abbr.includes(country.toUpperCase())) {
          prohibitLayer && prohibitLayer()
        }
      }
    } else {
      localStorage.setItem(adminSessionName, '1234AbCdEf')
    }
  }

  // 获取当前Shopify环境
  global.getShopifyEnv = function () {
    if (window.__localEnv == 'dev') {
      return 'dev'
    }

    return (window.__settingEnv || 'prod').trim().toLowerCase()
  }
  // 根据环境注入API相关变量
  global.injectInterfaceParams = function () {
    // 默认为生产
    const ENV = global.getShopifyEnv()
    let HT_API_CONFIG = {
      dev: {
        hostName: 'https://mall-gateway-dev.htwig.com',
        platCode: 'PC001',
        accountGroup: 'Luvme',
        platform: 'SHOPIFY',
        cryptoEncodeKey: '',
        cryptoDecodeKey: '',
      },
      test: {
        hostName: 'https://mall-gateway-test.htwig.com',
        platCode: 'PC001',
        accountGroup: 'Luvme',
        platform: 'SHOPIFY',
        cryptoEncodeKey: '',
        cryptoDecodeKey: '',
      },
      sit: {
        hostName: 'https://mall-gateway-sit.htwig.com:30504',
        platCode: 'PC6',
        accountGroup: 'Luvme',
        platform: 'SHOPIFY',
        cryptoEncodeKey: '',
        cryptoDecodeKey: '',
      },
      prod: {
        hostName: 'https://mall-gateway.htwig.com:31008',
        platCode: 'PC1',
        accountGroup: 'Luvme',
        platform: 'SHOPIFY',
        cryptoEncodeKey: '',
        cryptoDecodeKey: '',
      }
    }
    window.HT_API_CONFIG = HT_API_CONFIG[ENV]
    window.HT_SHOPIFY_ENV = ENV
    return HT_API_CONFIG[ENV]
  }

  // 拼接时间格式
  global.formatTime = function (date, yearMonth) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')
    const dateMonth = yearMonth == 'yy-mm-dd' ? `${year}-${month}-${day}` : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    return dateMonth
  }

  // UTC时间戳转换为纽约时间
  global.timestampToNewYorkTime = function (timestamp) {
    const date = new Date(timestamp) // 创建一个 Date 对象，传入时间戳
    // 创建一个纽约时区的日期格式化选项
    const options = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric', // 使用数字表示月份
      day: 'numeric', // 使用数字表示日期
      hour: '2-digit', // 使用两位数字表示小时
      minute: '2-digit', // 使用两位数字表示分钟
      second: '2-digit' // 使用两位数字表示秒钟
    }

    // 使用Intl.DateTimeFormat将Date对象格式化为纽约时间字符串
    const nyTimeString = new Intl.DateTimeFormat('en-US', options).format(date)

    return global.formatTime(new Date(nyTimeString), 'yy-mm-dd')
  }

  // 根据名称获取 Cookie 值
  global.getCookie = function (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift().replace(/"/g, '')
    }
  }

  // 根据传入的值实现 复制 功能
  global.copy = function (content, souccessText) {
    // 创建输入框元素
    const input = document.createElement('input')//不会保留文本格式
    //如果要保留文本格式，比如保留换行符，或者多行文本，可以使用  textarea 标签，再配和模板字符串 ` `
    //const input = document.createElement('textarea')
    // 将想要复制的值
    input.value = content
    // 页面底部追加输入框
    document.body.appendChild(input)
    // 选中输入框
    input.select()
    // 执行浏览器复制命令
    document.execCommand('Copy')
    // 复制后移除输入框
    input.remove()
    // 返回一个状态，可以用来处理是否弹出提示语 Copied
    window.publicComponents.messageOpen({
      type: 'success',
      content: souccessText,
      style: {
        'top': '20%'
      }
    })
  }

  // 截取url链接里面的指定参数
  global.UrlInterception = function (name) {
    const smsUrlParams = new URLSearchParams(window.location.search)
    return smsUrlParams.get(name) ? smsUrlParams.get(name) : ''
  }

  // 获取URL Search参数，返回object，多个相同KEY，后面覆盖前面
  global.getUrlParams = function (url = window.location.href) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }

    return decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .split('&')
      .reduce((r, item) => {
        const index = item.indexOf('=')

        if (!~index) {
          return r
        }

        const key = item.substring(0, index)
        const value = item.substring(index + 1)

        r[key] = value
        return r
      }, {})
  }

  // 函数节流
  global.throttle = function (func, delay = 1000) {
    let lastCallTime = 0
    let timeoutId

    return function (...args) {
      const currentTime = new Date().getTime()

      if (currentTime - lastCallTime >= delay) {
        func.apply(this, args)
        lastCallTime = currentTime
      } else {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          func.apply(this, args)
          lastCallTime = currentTime
        }, delay - (currentTime - lastCallTime))
      }
    }
  }

  // 逐行比较版本号
  /*
  version1: 比较的版本号
  version2: 被比较的版本号
  */
  global.compareVersions = function (version1, version2) {
    var version1Array = version1.split('.').map(Number)
    var version2Array = version2.split('.').map(Number)

    // 找出版本号中的最大长度
    var maxLength = Math.max(version1Array.length, version2Array.length)

    for (var i = 0; i < maxLength; i++) {
      var num1 = version1Array[i] || 0
      var num2 = version2Array[i] || 0

      if (num1 < num2) {
        return true // version1 < version2
      } else if (num1 > num2) {
        return false // version1 > version2
      }
    }

    return false // version1 = version2
  }

  // 获取APP版本
  /*
  souceType: android || ios ，不传则默认都取
  */
  global.getAppVersion = function (souceType) {
    const userAgent = navigator.userAgent.toLowerCase()
    const regex = souceType ? new RegExp(`luvme\/(${souceType})\/(\\d+\\.\\d+\\.\\d+)`) : /luvme\/(android|ios)\/(\d+\.\d+\.\d+)/
    const a = regex.exec(userAgent)
    return a && a.length >= 2 ? a[2] : ''
  }

  // 内容加密
  global.encryption = function (val) {
    const aseKey = "ABCD1234"//秘钥必须为：8/16/32位
    const encryptionValue = CryptoJS.AES.encrypt(val.toString(), CryptoJS.enc.Utf8.parse(aseKey), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
    return encryptionValue
  }

  // 内容解密
  global.Decrypt = function (encryptedText) {
    const aseKey = "ABCD1234" // 密钥必须是 8/16/32 位
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(aseKey), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8)
    return decryptedValue
  }

  // 统一的 Storefront GraphQL 配置（版本与端点）
  const STOREFRONT = {
    // 使用相对路径，避免暴露 myshopify 域名，同时确保随店域名工作
    // 强制使用稳定版本，避免使用unstable或dev版本
    endpoint: window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? (window.Shopify.routes.root + 'api/2025-04/graphql.json')
      : '/api/2025-04/graphql.json',
    // 现有主题内使用的 token（如需更换，集中在此处）
    token: 'a8cb1263711779dcd0c34d00ba5cfc67'
  }

  /** 供前台脚本（如 like-share.js）共用 Storefront 端点与 token，避免多处硬编码 */
  global.storefrontApi = STOREFRONT

  // CSRF Token 获取函数
  global.getCSRFToken = function () {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : null
  }

  // 安全的API请求函数，自动添加CSRF保护
  global.safeApiRequest = function (url, options = {}) {
    const csrfToken = global.getCSRFToken()
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    if (csrfToken) {
      defaultOptions.headers['X-CSRF-Token'] = csrfToken
    }

    // 合并选项
    const finalOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers
      }
    }

    return fetch(url, finalOptions)
  }

  // API端点安全验证函数
  global.validateApiEndpoint = function (endpoint) {
    // 禁止使用不稳定或开发版本的API端点
    const forbiddenPatterns = [
      /\/api\/unstable\//i,
      /\/api\/dev\//i,
      /\/api\/test\//i,
      /\/api\/staging\//i,
      /\/api\/beta\//i,
      /\/api\/alpha\//i
    ]

    return !forbiddenPatterns.some(pattern => pattern.test(endpoint))
  }

  // 安全的API请求包装器，自动验证端点 - 宽松模式
  global.safeApiCall = function (endpoint, options = {}) {
    // 宽松模式：只记录警告，不阻止请求
    if (!global.validateApiEndpoint(endpoint)) {
      console.warn('Security warning: Potentially unsafe API endpoint:', endpoint)
      // 在宽松模式下，仍然允许请求通过
    }

    return global.safeApiRequest(endpoint, options)
  }

  // 根据产品id获取产品信息
  global.getProductDetails = function (id) {
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `query {
              product(id: "gid://shopify/Product/${id}") {
                title
                tags
                onlineStoreUrl
                media(first: 20) {
                  edges {
                    node {
                      mediaContentType
                      alt
                      ...mediaFieldsByType
                    }
                  }
                }
                variants(first: 100) {
                  nodes {
                    id
                    quantityAvailable
                    title
                    price {
                      amount
                    }
                    compareAtPrice {
                      amount
                    }
                    sku
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
            fragment mediaFieldsByType on Media {
              ... on ExternalVideo {
                id
                embeddedUrl
              }
              ... on MediaImage {
                image {
                  url
                }
              }
              ... on Model3d {
                sources {
                  url
                  mimeType
                  format
                  filesize
                }
              }
              ... on Video {
                sources {
                  url
                  mimeType
                  format
                  height
                  width
                }
              }
            }`,
        })
      })
        .then(response => response.json())
        .then(data => {
          resolve(data.data.product)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * 使用 Storefront API 获取集合产品（支持按 tag / productType 筛选）
   * @param {string} collectionHandle - 集合 handle，如 'all' 或 'frontpage'
   * @param {object} options - { first: 24, after: cursor, filters: [{ tag: 'black' }] 或 [{ productType: 'Gel Polish' }] }
   * @returns {Promise<{ products: array, pageInfo: object }>}
   */
  global.getCollectionProductsWithFilters = function (collectionHandle, options) {
    const first = (options && options.first) || 24
    const after = (options && options.after) || null
    const filters = (options && options.filters) || []
    const sortKey = (options && options.sortKey) || null
    const reverse = (options && options.reverse) === true
    return new Promise((resolve, reject) => {
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }
      // variables：GraphQL 变量
      // - handle：集合 handle
      // - first：每次拉取条数（Storefront 上限 250）
      // - after：分页游标（可选）
      // - filters：筛选条件（可选）。注意：tag / productType 通常需要传“后台原始值”，不是 handle。
      const variables = {
        handle: collectionHandle,
        first: Math.min(first, 250)
      }
      if (filters.length) variables.filters = filters
      if (after) variables.after = after
      if (sortKey) variables.sortKey = sortKey
      if (reverse) variables.reverse = true

      // 这里做了两套 query：
      // - 有 filters：带 products(filters: $filters)
      // - 无 filters：不传 filters 参数（避免某些店铺/版本对 filters: [] 行为不一致）
      const query = filters.length
        ? `
        query GetCollectionProducts($handle: String!, $first: Int!, $filters: [ProductFilter!], $after: String, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
          collection(handle: $handle) {
            products(first: $first, filters: $filters, after: $after, sortKey: $sortKey, reverse: $reverse) {
              edges {
                node {
                  id
                  title
                  handle
                  productType
                  onlineStoreUrl
                  availableForSale
                  tags
                  featuredImage { url altText }
                  images(first: 2) { nodes { url altText } }
                  variants(first: 2) {
                    nodes {
                      id
                      availableForSale
                      price { amount currencyCode }
                      compareAtPrice { amount }
                    }
                  }
                }
                cursor
              }
              pageInfo { hasNextPage endCursor }
            }
          }
        }
      `
        : `
        query GetCollectionProducts($handle: String!, $first: Int!, $after: String, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
          collection(handle: $handle) {
            products(first: $first, after: $after, sortKey: $sortKey, reverse: $reverse) {
              edges {
                node {
                  id
                  title
                  handle
                  productType
                  onlineStoreUrl
                  availableForSale
                  tags
                  featuredImage { url altText }
                  images(first: 2) { nodes { url altText } }
                  variants(first: 2) {
                    nodes {
                      id
                      availableForSale
                      price { amount currencyCode }
                      compareAtPrice { amount }
                    }
                  }
                }
                cursor
              }
              pageInfo { hasNextPage endCursor }
            }
          }
        }
      `

      // 使用主题内统一的 Storefront token 访问 GraphQL
      // header: X-Shopify-Storefront-Access-Token
      fetch(STOREFRONT.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT.token
        },
        body: JSON.stringify({ query, variables })
      })
        .then(res => res.json())
        .then(data => {
          if (data.errors) {
            reject(new Error(data.errors.map(e => e.message).join('; ')))
            return
          }
          const collection = data.data && data.data.collection
          if (!collection || !collection.products) {
            resolve({ products: [], pageInfo: { hasNextPage: false, endCursor: null } })
            return
          }
          const products = collection.products.edges.map(e => ({ ...e.node, cursor: e.cursor }))
          resolve({
            products,
            pageInfo: collection.products.pageInfo
          })
        })
        .catch(err => reject(err))
    })
  }

  /**
   * getCollectionFilteredProductCount
   * Counts total filtered products and collects all cursors for direct page jumping.
   * Returns Promise<{ totalCount, cursors[], hasMore }>
   */
  global.getCollectionFilteredProductCount = function (collectionHandle, options) {
    const filters = (options && options.filters) || []
    const sortKey = (options && options.sortKey) || null
    const reverse = (options && options.reverse) === true
    const maxIterations = 10

    function fetchBatch (after, accumulated, iteration) {
      return new Promise((resolve, reject) => {
        if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
          reject(new Error('Unsafe API endpoint blocked'))
          return
        }
        const variables = { handle: collectionHandle, first: 250 }
        if (filters.length) variables.filters = filters
        if (after) variables.after = after
        if (sortKey) variables.sortKey = sortKey
        if (reverse) variables.reverse = true

        const query = filters.length
          ? `query($handle:String!,$first:Int!,$filters:[ProductFilter!],$after:String,$sortKey:ProductCollectionSortKeys,$reverse:Boolean){
              collection(handle:$handle){products(first:$first,filters:$filters,after:$after,sortKey:$sortKey,reverse:$reverse){edges{cursor}pageInfo{hasNextPage endCursor}}}}`
          : `query($handle:String!,$first:Int!,$after:String,$sortKey:ProductCollectionSortKeys,$reverse:Boolean){
              collection(handle:$handle){products(first:$first,after:$after,sortKey:$sortKey,reverse:$reverse){edges{cursor}pageInfo{hasNextPage endCursor}}}}`

        fetch(STOREFRONT.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT.token
          },
          body: JSON.stringify({ query, variables })
        })
          .then(r => r.json())
          .then(data => {
            if (data.errors) { reject(new Error(data.errors.map(e => e.message).join('; '))); return }
            const col = data.data && data.data.collection
            if (!col || !col.products) { resolve({ totalCount: accumulated.length, cursors: accumulated, hasMore: false }); return }
            const cursors = col.products.edges.map(e => e.cursor)
            const all = accumulated.concat(cursors)
            const pi = col.products.pageInfo
            if (pi.hasNextPage && iteration < maxIterations) {
              resolve(fetchBatch(pi.endCursor, all, iteration + 1))
            } else {
              resolve({ totalCount: all.length, cursors: all, hasMore: pi.hasNextPage })
            }
          })
          .catch(reject)
      })
    }

    return fetchBatch(null, [], 1)
  }

  // cart.js 全局获取购物车数据
  /* 通过接口获取购物车数据时，无法直接获取到购物车商品的标签，但是我们可以通过liquid的写法，在非购物车页面直接拿到，比如下面的写法，
  {% for item in cart.items %}
    chat_array.push({...{{item | json}},...{tags: {{item.product.tags | json}} }})
  {% endfor %}
  */
  global.getShoppingCartData = function () {
    return new Promise((resolve, reject) => {
      fetch(window.Shopify.routes.root + "cart.js").then(response => response.json())
        .then(data => {
          resolve(data) // 注：返回的数据无法获取到商品标签
        })
        .catch(error => { console.log(error); reject(error) })
    })
  }

  // cart/add.js 通过商品属性id向购物车添加商品数据，可以批量
  /*
  [{
    'id': xxx, // 商品属性id, variant_id
    'quantity': number
  }]
  */
  global.addItemsToCart = function (items) {
    let formDataPro = {
      'items': items
    }
    return new Promise((resolve, reject) => {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formDataPro)
      }).then(response => {
        return response.json()
      }).then((e) => {
        console.log('show add')
        resolve(e)
      }).catch((error) => {
        reject(error)
        console.log('Error:', error)
      })
    })

  }

  // cart/change.js 通过商品属性id单个修改购物车商品数量，为零时可以删除当前商品，
  global.modifyProductQuantity = function (id, number) {
    return new Promise((resolve, reject) => {
      let formData = {
        'id': id.toString(), // 商品属性id
        'quantity': number || 0 // 修改的数量，为零时，代表删除购物车的商品
      }
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        return response.json()
      }).then((e) => {
        resolve(e)
      }).catch((error) => {
        reject(error)
        console.log('Error:', error)
      })
    })
  }

  // cart/update.js 用于批量更新购物车的产品信息，为零时可以删除当前商品，全部为0，为清空购物车；
  /* 键：variant_id 值：数量，
  updates: {
    794864053: 0,
  }
  */
  global.updateProductQuantity = function (items) {
    return new Promise((resolve, reject) => {
      let formData = {
        updates: items
      }
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        return response.json()
      }).then((e) => {
        resolve(e)
      }).catch((error) => {
        reject(error)
        console.log('Error:', error)
      })
    })
  }

  // 根据价格获取积分
  global.calculate = function (value, memberEmail, callback) {
    let data = {
      memberEmail: memberEmail,
      price: value
    }

    postData(window.HT_API_CONFIG.hostName + '/crm/front/shopify/member/points/vipPoints/calculate', data)
      .then(response => {
        if (response.code === 'SUCCESS') {
          let Details = JSON.parse(htDecrypt(response.data))
          callback(Details.points) // 成功时调用回调并传递结果
        } else {
          callback(0) // 失败时调用回调并传递错误信息
        }
      })
      .catch(error => {
        callback(0)
      })
  }

  // 删除个人信息的地址
  /*
    addressId: 要为客户设置为新默认值的地址 ID
    customerAccessToken: 用于识别客户的访问令牌。
  */
  global.deleteAddress = function (addressId) {
    // const accessToken = localStorage.getItem('accessToken')
    // return new Promise((resolve, reject) => {
    //   fetch("https://9c35bd-26.myshopify.com/api/2025-04/graphql.json", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       "X-Shopify-Storefront-Access-Token": "a8cb1263711779dcd0c34d00ba5cfc67",
    //     },
    //     body: JSON.stringify({
    //       query: `
    //         mutation {
    //           customerAddressDelete(id: "${addressId}",customerAccessToken: "${accessToken}") {
    //             customerUserErrors {
    //                 message
    //             }
    //           }
    //         }`,
    //     })
    //   }).then(response => response.json()).then(data => {
    //     resolve(data)
    //   }).catch(error => console.error(error))

    // })
    return new Promise((resolve, reject) => {
      fetch(window.Shopify.routes.root + `account/addresses/${addressId}`, {
        method: 'DELETE',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(response => {
          console.log('show response', response)
          if (response.status === 200) {
            window.location.reload()
          } else {
            window.location.reload()
            // 处理删除失败的情况
            console.error("error", response)
          }
        })
        .catch(error => {
          window.location.reload()
          console.error("error: ", error)
        })
    })
  }

  // 修改个人信息
  /*
    acceptsMarketing: 户是否同意通过电子邮件发送营销材料。
    email: 客户的电子邮件
    firstName: 客户的名字
    lastName: 客户的姓氏
    password: 客户使用的登录密码
    phone: 客户的唯一电话号码
  */
  global.ModifyPersonalName = function (customer) {
    const accessToken = localStorage.getItem('accessToken')
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `
            mutation {
              customerUpdate(customer: {
                firstName: "${customer?.firstName}",
                lastName: "${customer?.lastName}",
              },customerAccessToken: "${accessToken}") {
                customerAccessToken {
                    accessToken
                }
                customerUserErrors {
                    message
                }
              }
            }
            `,
        })
      }).then(response => response.json()).then(data => {
        resolve(data)
      }).catch(error => console.error(error))

    })
  }

  // 修改默认地址呢
  /*
    addressId: 要为客户设置为新默认值的地址 ID
    customerAccessToken: 用于识别客户的访问令牌。
  */
  global.ModifyDefaultDddress = function (addressId) {
    const accessToken = localStorage.getItem('accessToken')
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `
            mutation {
              customerDefaultAddressUpdate(addressId: "${addressId}",customerAccessToken: "${accessToken}") {
                customer {
                  firstName
                  lastName
                  email
                  phone
                }
                customerUserErrors {
                    message
                }
              }
            }`,
        })
      }).then(response => response.json()).then(data => {
        resolve(data)
      }).catch(error => console.error(error))

    })
  }

  // 创建客户访问令牌
  /*
    email: 与客户关联的电子邮件
    password: 客户使用的登录密码
  */
  global.CreateAccessToken = function (email, password) {
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `
            mutation {
              customerAccessTokenCreate(input: { email: "${email}",password: "${password}"  }) {
                customerAccessToken {
                  accessToken
                }
                customerUserErrors {
                  message
                }
              }
            }`,
        })
      }).then(response => response.json()).then(data => {
        resolve(data)
      }).catch(error => console.error(error))

    })
  }

  // 获取登录用户的storeFront地址id
  global.loginUserInformation = function () {
    const accessToken = localStorage.getItem('accessToken')
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `query {
              customer(customerAccessToken: "${accessToken}") {
                addresses(first: 100) {
                  nodes {
                   id
                  }
                }
              }
            }`,
        })
      }).then(response => response.json()).then(data => {
        resolve(data)
      }).catch(error => console.error(error))
    })
  }

  // 处理压缩图片及回调函数
  global.compressAndUploadFile = async function (selectedFile, globalFn) {
    try {
      const compressedFile = await global.compressFile(selectedFile)

      const uploadPropertiesResponse = await postData(window.HT_API_CONFIG.hostName + '/bss/file/getFileUploadProperties', {
        bizType: 'mall_media_image',
        originalFileName: selectedFile.name,
      })

      const data = JSON.parse(htDecrypt(uploadPropertiesResponse.data))

      const { fields, uploadUrl, fileUrl } = data
      const formData = new FormData()
      for (const field of fields) {
        formData.append(field.key, field.value)
      }
      formData.append('file', compressedFile)
      // 上传图片到阿里云
      const uploadResult = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
      })
      // 返回成功的url
      globalFn(fileUrl)
    } catch (error) {
      console.log('error', error)
    }
  }

  // 压缩图片的file
  global.compressFile = function (selectedFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = function (e) {
        const img = new Image()

        img.onload = function () {
          const maxWidth = 800 // 最大宽度
          const maxHeight = 600 // 最大高度

          let width = img.width
          let height = img.height

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height

            if (width > height) {
              width = maxWidth
              height = width / aspectRatio
            } else {
              height = maxHeight
              width = height * aspectRatio
            }
          }

          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          // 不传默认为 PNG 格式，第二个参数默认为 PNG 的质量设置（0 到 1 之间）。
          const compressedDataUrl = canvas.toDataURL() // canvas.toDataURL('image/jpeg', 1)

          // 上传压缩后的图片
          resolve(global.compressBase64ToImageFile(compressedDataUrl, selectedFile.name, 'image/jpeg'))

        }

        img.src = e.target.result
      }

      reader.onerror = function (error) {
        reject(error)
      }

      reader.readAsDataURL(selectedFile)
    })
  }

  // 将转化为Blob对象转化为file
  global.compressBase64ToImageFile = function (base64Data, fileName, mimeType) {
    const blobData = global.dataUrlToBlob(base64Data, mimeType)
    return new window.originalFile([blobData], fileName, { type: mimeType })
  }

  // 将压缩后的图像base 64转换为 Blob 对象
  global.dataUrlToBlob = function (base64, mimeType) {
    const bytes = window.atob(base64.split(',')[1])
    const ab = new ArrayBuffer(bytes.length)
    const ia = new Uint8Array(ab)
    for (let index = 0; index < bytes.length; index++) {
      /**
      * 非空断言
      */
      ia[index] = bytes.codePointAt(index)
    }
    console.log('show blob', ab, new Blob([ab], { type: mimeType }))
    return new Blob([ab], { type: mimeType })
  }

  //客户端时间转换为北京时间
  global.getBeijingtime = function () {
    //获得当前运行环境时间
    let d = new Date()
    let currentDate = new Date()
    let tmpHours = currentDate.getHours()
    //算得时区
    let time_zone = -d.getTimezoneOffset() / 60
    if (time_zone < 0) {
      time_zone = Math.abs(time_zone) + 8; currentDate.setHours(tmpHours + time_zone)
    } else {
      time_zone -= 8; currentDate.setHours(tmpHours - time_zone)
    }
    return currentDate
  }

  // 获取url里面所携带指定参数
  global.GetQueryString = function (url) {
    var reg = new RegExp("(^|&)" + url + "=([^&]*)(&|$)")
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2]); return ''
  }

  // 获取博客信息
  global.getBlogList = function (handle) {
    return new Promise((resolve, reject) => {
      // 验证API端点安全性
      if (!global.validateApiEndpoint(STOREFRONT.endpoint)) {
        reject(new Error('不安全的API端点被阻止'))
        return
      }

      fetch(STOREFRONT.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT.token,
        },
        body: JSON.stringify({
          query: `
            query {
              blogs(first: 50 ${handle ? `,query: "handle:${handle}"` : ''}) {
                edges {
                  node {
                    id
                    title
                    handle
                    articles(first: 250,reverse: true) {
                      edges {
                        cursor
                        node {
                          id
                          title
                          blog {
                            handle
                          }
                          authorV2{
                            name
                          }
                          content
                          publishedAt
                          handle
                          tags
                          metafields(identifiers: [{ namespace: "custom", key: "sort" },{ namespace: "custom", key: "category" }]) {
                            key
                            value
                          }
                          image {
                            url
                            height
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`,
        })
      }).then((response) => response.json())
        .then((data) => {
          resolve(data)
        }).catch((error) => console.error(error))
    })
  }

  // 商品卡片图片懒加载 + 占位符
  // 1）IntersectionObserver 进入视口时才把 data-src / data-srcset 填回 src / srcset
  // 2）加载失败或异常时，显示占位文案
  global.initIntersectionLazyImages = function () {
    const selector = 'img[is="image-lazy"][data-src]'
    const images = document.querySelectorAll(selector)
    if (!images || !images.length) return

    const loadImage = (img) => {
      if (img.dataset.loaded === 'true') return

      const realSrc = img.getAttribute('data-src')
      const realSrcset = img.getAttribute('data-srcset')

      if (realSrc) {
        img.setAttribute('src', realSrc)
      }
      if (realSrcset) {
        img.setAttribute('srcset', realSrcset)
      }

      img.dataset.loaded = 'true'
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const img = entry.target
            loadImage(img)
            obs.unobserve(img)
          }
        })
      }, {
        root: null,
        rootMargin: '150px 0px',
        threshold: 0.01
      })

      images.forEach((img) => observer.observe(img))
    } else {
      // 不支持 IntersectionObserver 的浏览器，直接加载
      images.forEach((img) => loadImage(img))
    }
  }

  // 商品卡片图片未正常加载时显示占位文案（失败或超时）
  global.initProductImagePlaceholders = function () {
    const selector = 'img[is="image-lazy"]'
    const images = document.querySelectorAll(selector)
    if (!images || !images.length) return

    images.forEach((img) => {
      const container = img.closest('.product-card-simple__image, .product-card__image')
      if (!container) return

      const clearPlaceholder = () => {
        container.classList.remove('show-placeholder')
        img.style.display = ''
        img.style.opacity = ''
        img.style.position = ''
        img.style.inset = ''
        img.style.pointerEvents = ''
      }

      const showPlaceholder = () => {
        container.classList.add('show-placeholder')
        img.style.display = 'none'
      }

      if (img.complete && img.naturalWidth > 0) {
        clearPlaceholder()
        return
      }

      img.addEventListener('error', showPlaceholder, { once: true })
      img.addEventListener('load', clearPlaceholder, { once: true })

      // 超时兜底：例如 CDN 挂起但不触发 error 的情况
      // 仅对已经有 src 的图片做超时检测，避免还没进入视口的懒加载图片被误判
      if (img.getAttribute('src')) {
        const TIMEOUT = 3000
        setTimeout(() => {
          if (!img.complete || img.naturalWidth === 0) {
            showPlaceholder()
          }
        }, TIMEOUT)
      }
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (global.initIntersectionLazyImages) {
      global.initIntersectionLazyImages()
    }
    if (global.initProductImagePlaceholders) {
      global.initProductImagePlaceholders()
    }
  })

})(window.globalFn || (window.globalFn = {}))// 全局函数、禁止写自运行函数
